import getRandomColor from './getRandomColor.js'

const pickBy = object => {
  const obj = []
  for (const key in object) {
    if (
      object[key] !== null &&
      object[key] !== false &&
      object[key] !== undefined &&
      typeof object[key] === 'number'
    ) {
      obj.push({ key: key, color: getRandomColor() })
    }
  }
  return obj
}

const generateDataKeys = (data, xAxis, yAxis) =>
  data
    .map(x => pickBy(x))
    .flat()
    .filter((element, index, array) => {
      return (
        array.map(mapArray => mapArray['key']).indexOf(element['key']) === index
      )
    })
    .filter(item => item.key !== xAxis && item.key !== yAxis)

export default generateDataKeys
